// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PwPl","content":"styles_content__1aa7w","tableWrap":"styles_tableWrap__3rcSD"};